import React, {useState} from 'react'
import {Button, Form, Input, Modal} from "antd";
import { updateAddress } from "../../services/serviceAddress";
import {enterLoadingState, exitLoadingState} from "../../utils/helpers/commonFunctions";


const { TextArea } = Input

const AddressesEdit = ({record, updater}) => {

    const [form] = Form.useForm()
    const [showModal, setShowModal] = useState(false)
    const [loadings, setLoadings] = useState([])

    const handleEditClick = () => {
        setShowModal(!showModal)
    }

    const handleSubmit = () => {
        enterLoadingState(setLoadings)
        const {
            title,
            address
        } = form.getFieldsValue()

        let requestObj = {
            title: title,
            address: address,
            customer: {
                id: record.customerObj.id
            },
            id: record.key,
        }

        updateAddress(requestObj)
            .then(() => {
                exitLoadingState(setLoadings)
                setShowModal(!showModal)
                updater()
            })
            .catch(() => exitLoadingState(setLoadings))
    }

    return (
        <React.Fragment>
            <Button
                type={'link'}
                onClick={handleEditClick}
            >
                Güncelle
            </Button>

            <Modal
                open={showModal}
                onCancel={() => setShowModal(!showModal)}
                title={'Adres Güncelle'}
                footer={[
                    <Button
                        type={'primary'}
                        key={'SubmitButton'}
                        loading={loadings[0]}
                        onClick={() => form.submit()}
                    >
                        Kaydet
                    </Button>,
                    <Button
                        key={'CancelButton'}
                        onClick={() => setShowModal(!showModal)}
                    >
                        Kapat
                    </Button>
                ]}
            >
                <Form
                    form={form}
                    name={'addressUpdate'}
                    onFinish={handleSubmit}
                    labelAlign={"left"}
                    wrapperCol={{span: 16}}
                    labelCol={{span: 8}}
                >
                    <Form.Item
                        name={'title'}
                        label={'Başlık'}
                        initialValue={record.title}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        name={'address'}
                        label={'Adres'}
                        initialValue={record.address}
                    >
                        <TextArea />
                    </Form.Item>
                </Form>
            </Modal>
        </React.Fragment>
    )
}
export default AddressesEdit